{
  "loginForm": {
    "button": {
      "create": "loginForm.button.create",
      "forgot": "Abschicken",
      "login": "Anmelden",
      "reset": "loginForm.button.reset",
      "update": "loginForm.button.update"
    },
    "header": {
      "create": "loginForm.header.create",
      "forgot": "Passwort vergessen",
      "login": "Willkommen",
      "reset": "loginForm.header.reset",
      "update": "loginForm.header.update"
    },
    "label": {
      "create": "Jetzt erstellen!",
      "createPrefix": "Kein Account?",
      "email": "Email",
      "forgotPassword": "Passwort vergessen?",
      "password": "Passwort",
      "rememberMe": "Angemeldet bleiben",
      "username": "Benutzer"
    }
  }
}
